import { envUtils } from '@/utils/envUtils'

const 매쓰플랫_가이드_사이트 = envUtils.isLive
  ? 'https://guide.mathflat.com'
  : 'https://guide-staging.mathflat.com'

export const outerLink = {
  스쿨플랫_공통_앱사용가이드_링크: 'https://guide-schoolflat.oopy.io',
  매쓰플랫_앱사용가이드_링크: 매쓰플랫_가이드_사이트,
  크레버스_앱사용가이드_링크: 'https://userguide.mathflat.com',
  크레버스_학생앱_사용가이드_링크: 'https://userguide.mathflat.com/student.html',
  스쿨플랫_시그니처교재_콘텐츠자료실_링크:
    'https://www.notion.so/freewheelin/d22c27ad00544dca99eace3d80356837',
  스쿨플랫_유형분석_취약유형_링크:
    'https://www.notion.so/freewheelin/722e3b119a574951aaeb9a92f6fa318e',
  스쿨플랫_학력평가_시험_메뉴얼_링크:
    'https://freewheelin.notion.site/879377bbe4c0416b8466f9deae653981',
  스쿨플랫_프린트연결이_끊겼을_경우_링크:
    'https://freewheelin.notion.site/c273491ade784ce9b78f2e22ce046079',
  스쿨플랫_인쇄하기_가이드_링크:
    'https://freewheelin.notion.site/PC-ca7df8aaec4944668792ca21fdb95988',
  매쓰플랫_인쇄하기_가이드_링크: `${매쓰플랫_가이드_사이트}/guide/teacher/print-install`,
  매쓰플랫_프린트연결이_끊겼을_경우_링크: `${매쓰플랫_가이드_사이트}/guide/teacher/printer-troubleshoot`,
  스쿨플랫_공지사항_링크:
    'https://www.notion.so/freewheelin/8c548c575ca745b2a11f70ae1a2cc1e5?v=45134a730015455f8c39fa040d9fad32',
  스쿨플랫_카카오톡_채널_링크: 'http://pf.kakao.com/_hxoxjkG',
  매쓰플랫_카카오톡_채널_링크: 'http://pf.kakao.com/_jxcuwC',
  프리미엄_상담_신청_링크: 'https://u4wa3amsjw1.typeform.com/to/EZEfWrGE',
  스쿨플랫_홈페이지_링크: 'https://www.schoolflat.com',
  스쿨플랫_PC앱_다운로드_링크: 'https://schoolflat.com/p.exe',
  크롬_브라우저_다운로드_링크: 'https://www.google.com/intl/ko/chrome/',
  KMM_홍보물_링크: 'https://hill-structure-ae3.notion.site/KMM-231f64225de480e49aeee0157b8f1d9d',
  KMM_샘플시험지_링크:
    'https://hill-structure-ae3.notion.site/253f64225de481a3b8efea355c783109?source=copy_link',
  KMM_후기영상_링크:
    'https://hill-structure-ae3.notion.site/253f64225de481ab9bd2ff8add7fe842?source=copy_link',
  KMM_계약_신청_구글폼_링크:
    'https://docs.google.com/forms/d/e/1FAIpQLSdx8kGZBE4DZdhnfu0-Fs0XkCXVaYwRNhrSsp9bxeAyFAxucA/viewform',
  KMM_연간_시험일정_범위_링크:
    'https://hill-structure-ae3.notion.site/2c3f64225de480f194eef72e7fb0af50?source=copy_link',
  기출분석_템플릿_다운로드_링크:
    'https://drive.usercontent.google.com/u/0/uc?id=1zG1pN6H-WO8nfA1uoILh05M-yVe8sCmB&export=download',
  홈화면_프레이머_링크:
    'https://updated-contents.framer.website/support-for-most-commercial-textbooks',
  매쓰플랫_로그인화면_배너_링크:
    'https://updated-contents.framer.website/support-for-most-commercial-text-new-tab',
  매쓰플랫_홈페이지_개인정보_처리방침: 'https://www.mathflat.com/private',
  스쿨플랫_홈페이지_개인정보_처리방침: 'https://www.schoolflat.com/private',
  매쓰플랫_보고서_생성_가이드_링크:
    'https://www.mathflat.com/news/update/%ec%89%bd%ea%b2%8c-%ec%9d%bd%ed%9e%88%ea%b3%a0-%eb%b0%94%eb%a1%9c-%ea%b3%b5%ec%9c%a0%ed%95%98%eb%8a%94-%eb%a7%a4%ec%93%b0%ed%94%8c%eb%9e%ab-%eb%b3%b4%ea%b3%a0%ec%84%9c/',
  스쿨플랫_보고서_생성_가이드_링크:
    'https://guide-schoolflat.oopy.io/1c3f6422-5de4-81a3-a161-c339addaa7df',
  매쓰플랫_서술형_AI채점_소개_링크: 'https://essay-ai-grade-mathflat.vercel.app/',
  스쿨플랫_서술형_AI채점_소개_링크: 'https://essay-ai-grade-schoolflat.vercel.app/',
  학교별기출_정책_가이드_링크: `${매쓰플랫_가이드_사이트}/guide/teacher/school-past`,
  매쓰플랫_실험실_AI튜터_가이드_링크: `${매쓰플랫_가이드_사이트}/guide/teacher/laboratory#ai-tutor`,
  스쿨플랫_실험실_사용가이드_링크:
    'https://www.notion.so/freewheelin/f326e2791d774f3bb16ce5e32b10dc92',
  매쓰플랫_원클릭복습학습지_사용가이드_링크: `${매쓰플랫_가이드_사이트}/guide/teacher/worksheet-oneclick-review`,
  스쿨플랫_원클릭복습학습지_사용가이드_링크:
    'https://hill-structure-ae3.notion.site/1c3f64225de4815b93a9ca1949e6d599?source=copy_link',
  크레버스_직원_로그인_링크: envUtils.isLive
    ? 'https://account.creverse.com/mglogin/staff'
    : 'https://accountvlc.cdwide.com/mglogin/staff',
  스쿨플랫_B2G_이벤트_배너_링크:
    'https://story.schoolflat.com/365f6422-5de4-80eb-9a01-fb49f3bf656b',
  수식_가이드_링크: 'https://latex-guide.vercel.app',
  // 영어는 서브도메인이 환경을 담지만 매쓰와 접미사 규칙이 달라(-stage/-dev) 호스트명 치환이 성립하지 않는다.
  잉글리시플랫_선생님앱_링크: envUtils.isLive
    ? 'https://teacher.englishflat.com'
    : envUtils.isStaging
      ? 'https://teacher-stage.englishflat.com'
      : 'https://teacher-dev.englishflat.com',
  잉글리시플랫_얼리버드_신청_GNB_링크:
    'https://earlybird.englishflat.com/?utm_source=mathflat&utm_medium=gnb',
  스쿨플랫_잉글리시플랫_얼리버드_신청_GNB_링크:
    'https://earlybird.englishflat.com/?utm_source=schoolflat&utm_medium=gnb',
  잉글리시플랫_얼리버드_신청_GNB_배너_링크:
    'https://earlybird.englishflat.com/?utm_source=mathflat&utm_medium=gnb_banner',
}
